
import '../scss/filterApp.scss';

import './scripts/filterApp/index.js';